import React, { ReactElement } from "react";

import Icon, { IconName } from "../Icon";

export type TextSwitcherIcon = {
  name: IconName;
  className?: string;
};

export type TextSwitcherText =
  | {
      icon: TextSwitcherIcon;
      paragraph?: ReactElement;
    }
  | {
      icon?: TextSwitcherIcon;
      paragraph: ReactElement;
    };

interface TextSwitcherProps {
  texts: TextSwitcherText[];
}

const TextSwitcher = ({ texts = [] }: TextSwitcherProps) => {
  return (
    <div className="text-switcher">
      <div className="text-switcher__wrapper">
        {texts.map(({ icon, paragraph }, index) => (
          <div key={index} className="text-switcher__item">
            {icon && <Icon width={24} height={24} name={icon.name} className={icon.className} />}
            {paragraph && <div className="text-switcher__paragraph">{paragraph}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextSwitcher;
